import React from "react";
import InputCheckbox from "../../components/InputCheckbox";
import InputNumberOnly from "../../components/InputNumberOnly";
import { Upload, message, Button, Row, Col, Typography } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  setItem,
  removeItem,
  getItem,
  getPaymentUser,
  getPaymentGroup,
  formatAmount,
  labelsPerFrequency,
} from "utils";
import checkCircle from "../../assets/img/check-circle.png";
import checkCircleDefault from "../../assets/img/check-circle-default.png";
import { useDraggable } from "react-use-draggable-scroll";
import { useParams } from "react-router-dom";
import { Radio } from "antd";

import { AiOutlineCheck } from "react-icons/ai";
import { FaAward } from "react-icons/fa";

import BenefitItem from "../BenefitItem"

export default function Plan({
    id,
    name,
    selected,
    setSelected,
    planDetails,
    yearlyDiscount,
    ...item
  }) {
  
    const [show, setShow] = React.useState(false);
  
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "50px",
        }}
      >
        <p className="__signup-embed-name" style={{ textAlign: "center" }}>
          {name || item?.description}
        </p>
  
        <div
          className={`__signup-embed-cardContainer ${
            selected ? "__signup-embed-cardContainer-selected" : ""
          }`}
          onClick={() => {
            setSelected(id);
          }}
        >
          <div style={{ position: "relative", justifyContent: "center" }}>
            <img
              src={planDetails?.image}
              width="500px"
              height="124px"
              style={{
                width: "100%",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                height: "auto",
              }}
            />
            <div className="__signup-embed-infoContainer">
              <div className="__signup-embed-description">
                {/* <p className="__signup-embed-description">{planDetails?.description}</p> */}
  
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <p className="__signup-embed-plan-value">
                      <p style={{ margin: 0, color: "#FFF" }}>
                        {formatAmount(item?.value * 100)}{" "}
                        <span>{labelsPerFrequency[item.frequency]}</span>
                      </p>
                      {yearlyDiscount?.value && item.frequency === "YEARLY" && (
                        <span className="__signup-embed-plan-value-discount">
                          {`Economize ${formatAmount(
                            yearlyDiscount?.value * 100
                          )}`}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ margin: 10, marginBottom: 0, position: "relative" }}>
            <div className="__signup-embed-tagContainer">
              <p className="__signup-embed-tagText">{planDetails?.tag}</p>
            </div>
  
            <p className="__signup-embed-title">{planDetails?.title}</p>
            <p className="__signup-embed-subTitle">{planDetails?.subTitle}</p>
          </div>
  
          <div
            className="__signup-embed-borderDivider"
            style={{ marginTop: 20 }}
          />
  
          <div
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              overflow: "hidden",
              transition: "height 200ms",
            }}
          >
            {selected && (
              <div className="__signup-embed-benefit-container">
                {planDetails?.benefits?.map((item, index) => (
                  <BenefitItem
                    text={item.label}
                    leftAdornment={item.leftAdornment}
                    check={item.check}
                    highlighted={item.highlighted}
                    special={item.special}
                    id={`benefits-${index}`}
                    key={`benefits-${index}`}
                  />
                ))}
  
                <Button
                  type="submit"
                  label="Começar"
                  style={{ primary: { marginTop: 20 } }}
                  // onClick={() => {
                  // fn("setOnboarding", { plan: id });
                  // fn("setStep", 2);
                  // }}
                />
                <p
                  style={{
                    fontSize: 12,
                    textAlign: "center",
                    margin: "10px 30px",
                  }}
                >
                  Ao assinar, você aceita os{" "}
                  <a style={{ fontSize: 12, color: "#0074cc" }}>
                    {" "}
                    Termos e condições{" "}
                  </a>
                  do clube benefícios.
                </p>
              </div>
            )}
          </div>
  
          <div
            className="__signup-embed-borderDivider"
            style={{ marginTop: -1 }}
          />
          {!selected && (
            <button
              type="button"
              onClick={() => {
                setShow((prev) => !prev);
              }}
              className="__auth-button-outlined"
              style={{ color: "#7f7f7f", border: "none" }}
            >
              Ver mais
            </button>
          )}
          <div
            className="__signup-embed-borderDivider"
            style={{ marginTop: -1 }}
          />
  
          <Radio
            className={`__signup-embed-plan-radio ${
              selected && "__signup-embed-plan-radio-selected"
            }`}
            value={id}
            style={{ alignSelf: "center", margin: "20px", alignItems: "center" }}
          >
            {selected ? "Selecionado" : "Selecionar"}
          </Radio>
        </div>
      </div>
    );
  }
  